import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

interface ImagePreviewModalProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  alt?: string;
}

export function ImagePreviewModal({
  open,
  onClose,
  imageUrl,
  alt = "Pré-visualização da imagem",
}: ImagePreviewModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm" />

        <Dialog.Content
          aria-describedby="dialog-image-description"
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          {/* 🔐 Elementos para acessibilidade */}
          <Dialog.Title className="sr-only">Visualização da imagem</Dialog.Title>
          <Dialog.Description id="dialog-image-description" className="sr-only">
            Imagem em tamanho ampliado
          </Dialog.Description>

          {/* 🖼 Imagem exibida */}
          <img
            src={imageUrl}
            alt={alt}
            className="max-h-[90vh] max-w-[90vw] rounded-lg object-contain shadow-lg"
          />

          {/* ❌ Botão de fechar */}
          <Dialog.Close
            className="absolute right-4 top-4 text-white transition-colors hover:text-red-400"
            aria-label="Fechar"
          >
            <X className="h-6 w-6" />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
